/* Keeps "Custom 3D Print - Quote Credit" lines at the quantity set by the quote.
 * After any cart change, if a line has a hidden _Quote credits property and its quantity differs,
 * reset it with /cart/change.js. Removing a line (quantity 0) is always allowed. */
(function () {
  if (window.kcQuoteQtyGuard) return;
  window.kcQuoteQtyGuard = true;
  var busy = false;
  var origFetch = window.fetch;
  var isMutation = function (url) { return /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(String(url)); };

  function check() {
    if (busy) return Promise.resolve();
    busy = true;
    return origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fix = null;
        (cart.items || []).forEach(function (it, i) {
          var want = parseInt(it.properties && it.properties['_Quote credits'], 10);
          if (!fix && want > 0 && it.quantity !== want) fix = { line: i + 1, quantity: want };
        });
        if (!fix) return false;
        return origFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(fix)
        }).then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (changed) {
          if (document.querySelector('cart-items, cart-drawer') || /^\/cart\/?$/.test(location.pathname)) location.reload();
          else check();
        }
      })
      .catch(function () { busy = false; });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!busy && isMutation(url)) p.then(function () { setTimeout(check, 50); }, function () {});
    return p;
  };

  if (/^\/cart\/?$/.test(location.pathname)) check();
  window.kcQuoteQtyCheck = check;
})();
